import assetPath from '/app/xinglets/business-solutions/page/src/assets/logos/svg/xingButterfly.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')